module.exports = __webpack_public_path__ + "media/application/images/icons/search-960ff9b215d6c0cd15349eb9577c6623.svg";